import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICreateVoucherDto,
  IDictionaryItem,
  IFilterBase,
  IPaginationResponse,
  IParticipate,
  ISearchAddCashVoucherData,
  ISearchVoucherResult,
  IVoucher,
  IVoucherCorrectSumDto,
} from '@lib/interfaces';
import { httpParamsUtil, VouchersApiUrlsUtil } from '@lib/utils';
import { ApiChecksEnum, ApiUrlsEnum } from '@lib/enums';
import { FileTransferService } from './file-transfer.service';
import {VouchersRequestDto} from "@core/dto/requests/vouchers-request.dto";

@Injectable({
  providedIn: 'root'
})
export class VouchersDataService extends FileTransferService{

  public getVouchers(filter: VouchersRequestDto): Observable<IPaginationResponse<IVoucher>> {
    const params = httpParamsUtil(filter);

    return this.http.get<IPaginationResponse<IVoucher>>(`${environment.host}${ApiChecksEnum.voucherList}`, { params });
  }

  public memberDetail(id: number): Observable<IParticipate> {

    return this.http.get<IParticipate>(`${environment.host}${ApiUrlsEnum.memberDetail}${id}`);
  }

  public voucherDetail(id: number): Observable<IVoucher> {

    return this.http.get<IVoucher>(`${environment.host}${ApiChecksEnum.voucherDetails}${id}`);
  }

  public delete(id: number): Observable<any> {

    return this.http.delete(`${environment.host}${ApiChecksEnum.deleteVoucher}${id}`);
  }

  public correctSum(dto: IVoucherCorrectSumDto): Observable<IVoucher> {

    return this.http.post<IVoucher>(`${environment.host}${ApiChecksEnum.voucherCorrectSum}`, dto);
  }

  public searchVoucher(filter: ISearchAddCashVoucherData): Observable<ISearchVoucherResult> {
    return this.http.post<ISearchVoucherResult>(`${environment.host}${ApiChecksEnum.search}`, filter);
  }

  public bindCustomerWithVoucher(data: ISearchAddCashVoucherData): Observable<any> {

    return this.http
      .post(
        `${environment.host}${VouchersApiUrlsUtil.bindCustomer(data.voucherId, data.customerId)}`,
        { comment: data.comment }
      );
  }

  public goodsAutocomplete(filter: Partial<IFilterBase>): Observable<Array<IDictionaryItem>> {
    const params = httpParamsUtil({ filter: filter.filter });

    return this.http.get<Array<IDictionaryItem>>(`${environment.host}${ApiUrlsEnum.promoSetGoods}`, { params });
  }

  public createVoucher(data: ICreateVoucherDto): Observable<IVoucher> {

    return this.http.post<IVoucher>(`${environment.host}${ApiChecksEnum.voucherDetails}`, data);
  }
}
